import { createSelector } from 'reselect';
import { Scope, Status } from '@wix/ambassador-blog-v3-blog/types';
import { type AppState } from '../../types';

export const getCurrentUser = (state: AppState) => state?.auth?.currentUser;

const getCurrentUserPermissions = createSelector(
  [getCurrentUser],
  (currentUser) => currentUser?.permissions,
);

export const getCurrentUserSiteMemberId = createSelector(
  [getCurrentUserPermissions],
  (permissions) => permissions?.siteMemberId,
);

export const getCurrentUserRole = createSelector(
  [getCurrentUserPermissions],
  (permissions) => permissions?.scope ?? Scope.GUEST,
);

export const isBlocked = createSelector(
  [getCurrentUserPermissions],
  (permissions) => permissions?.isBlocked ?? false,
);

export const isPrivate = createSelector(
  [getCurrentUserPermissions],
  (permissions) => permissions?.privacyStatus === Status.PRIVATE,
);

export const getIsUserGuestWriter = createSelector(
  [getCurrentUserRole],
  (role) => role === Scope.GUEST_WRITER,
);
